import React from 'react';
import PropTypes from 'prop-types';

const ContentGrid = ({ items, maxImagesPerRow = 2 }) => {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-${maxImagesPerRow} gap-8 p-4`}>
      {items.map((item, index) => (
        <div
          key={index}
          onClick={item.onClick}
          className={`
            relative 
            w-full 
            overflow-hidden 
            cursor-pointer 
            rounded-lg
            flex 
            flex-col 
            justify-between 
            h-[280px] 
            sm:h-[320px] 
            lg:h-[350px]
            transition-transform 
            duration-300 
            ease-in-out 
            hover:scale-105
            shadow-md
            ${item.color ? '' : 'bg-gray-100'}
          `}
          style={item.color ? { background: item.color } : {}}
        >
          <div className="relative h-2/3 overflow-hidden">
            <img
              src={item.imgUrl}
              alt={item.title}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="p-4 pb-8 text-lg font-light max-w-[50%] text-white bg-transparent">
            {item.title}
          </div>
        </div>
      ))}
    </div>
  );
};

ContentGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      onClick: PropTypes.func,
      color: PropTypes.string,
    })
  ).isRequired,
  maxImagesPerRow: PropTypes.number,
};

export default ContentGrid;